import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('reseller.routes.edit'),
        name: 'reseller.edit',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "reseller" */ '@/views/reseller/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('reseller.breadcrumbs.edit'),
                    to: { name: 'reseller.edit' },
                    disable: true,
                },
            ],
        },
    },
]
